import type { PaletteRgbColors, RicosTheme } from './../../../ricos-types';

export const isRicosPaletteRgb = (palette: RicosTheme['palette']): palette is PaletteRgbColors =>
  typeof palette === 'object' && 'type' in palette && palette.type === 'rgb';
